module.exports = __webpack_public_path__ + "img/customer_design_2@2x.c949a68.webp";